import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, computed, input, output } from "@angular/core";
import { MatSortModule, Sort } from "@angular/material/sort";

import { DnsFirewallTypeEdge, PageInfo } from "../../../apis/networkdashboard/graphql/graphql";
import { Pagination, PaginationStyle } from "../../common/pagination/pagination";

@Component({
  selector: "cert-dns-firewall-table",
  templateUrl: "cert-dns-firewall-table.html",
  styleUrl: "cert-dns-firewall-table.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatSortModule, Pagination, TranslatePipe],
})
export class CertDNSFirewallTable {
  public dnsFirewallLogs = input.required<DnsFirewallTypeEdge[]>();
  public pageInfo = input.required<PageInfo>();
  protected paginationChanged = output<number>();
  protected sortingChanged = output<Sort>();
  protected paginationStyle = PaginationStyle.Numbered;
  protected pageSizeChanged = output<number>();
  protected emptyResult = computed(() => this.dnsFirewallLogs().length === 0);

  protected onPaginationChanged($event: number) {
    this.paginationChanged.emit($event);
  }

  protected sortData($event: Sort) {
    this.sortingChanged.emit($event);
  }

  protected onPageSizeChanged(v: number) {
    this.pageSizeChanged.emit(v);
  }
}
